
	export default {
		props: ['product', 'placeholder', 'single'],
		data(){
			return {
				storeType: 'course',
				// storeType: (this.product.title.toLowerCase().includes('in the jam') || this.product.title.toLowerCase().includes('(premium)')) ? 'itj' : 'course',
				showCollections: false,
				loggedIn: false,
				id: this.product.id
			}
		},
		methods: {
			openCollections() {
				if (this.loggedIn) this.showCollections = true;
				else location.href = `/login`;
			}
		},
		async created(){
			if(this.product && (this.product.title)){
				if(this.product.title.toLowerCase().includes('in the jam') || this.product.title.toLowerCase().includes('(premium)'))
					this.storeType = 'itj'
				this.$parent.storeType = this.storeType
			}
			
			const member = await this.$member.get(['memberusername']);
			if (member.memberusername) this.loggedIn = true;

			switch (this.$parent.storeType) {
				case 'course':
					this.id = '/c' + this.id;
					break;
				case 'itj':
					this.id = '/j' + this.id;
					break;
			}
		}
	}
